import { render, staticRenderFns } from "./L3MaskEditor.vue?vue&type=template&id=38c69ce0&scoped=true"
import script from "./L3MaskEditor.vue?vue&type=script&lang=js"
export * from "./L3MaskEditor.vue?vue&type=script&lang=js"
import style0 from "./L3MaskEditor.vue?vue&type=style&index=0&id=38c69ce0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38c69ce0",
  null
  
)

export default component.exports